module.exports = new __parcel__URL__("projects-files.f05b136a.svg").toString();